export const muiDataTableToolbarThemeOverrides = {
    styleOverrides: {
        root: {
            boxSizing: "border-box",
        },
        icon: {
            padding: 6,
            "& .MuiSvgIcon-root": {
                fontSize: 18,
            },
        },
        iconActive: {
            padding: 6,
            "& .MuiSvgIcon-root": {
                fontSize: 18,
            },
        },
    },
};

export const muiDataTableSearchThemeOverrides = {
    styleOverrides: {
        main: {
            minWidth: 0,
            alignItems: "center",
        },
        searchIcon: {
            flex: "0 0 auto",
            fontSize: 18,
        },
        searchText: {
            minWidth: 0,
            margin: 0,
        },
        clearIcon: {
            boxSizing: "border-box",
            width: 30,
            height: 30,
            padding: 6,
            "& .MuiSvgIcon-root": {
                fontSize: 18,
            },
        },
    },
};

export const muiDataTableHeadCellThemeOverrides = {
    styleOverrides: {
        root: {
            fontSize: "0.8125rem",
            lineHeight: 1.35,
            fontWeight: 700,
            "& .MuiButtonBase-root": {
                fontSize: "inherit",
                lineHeight: "inherit",
                fontWeight: 700,
            },
            "& [class*='MUIDataTableHeadCell-data']": {
                lineHeight: "inherit",
            },
        },
    },
};
